import {signProxy} from '@/api/index';

function signUpload(params){
    return signProxy.post('', params);
}

export {signUpload};